var exports = {
  "h": "FeatureGrid__CZMOR2",
};

module.exports = exports;
